import React from 'react';
import { IconBuildingBank } from '@tabler/icons';
import SimpleLookupCrud from './SimpleLookupCrud';

const Banks = () => (
    <SimpleLookupCrud
        icon={IconBuildingBank}
        gradient="graphite"
        title="Bancos"
        subtitle="Lista de bancos (código FEBRABAN) usada nas contas bancárias da empresa"
        endpoint="banks"
        addLabel="Novo banco"
        columns={[
            { key: 'code', label: 'Código', type: 'text', required: true },
            { key: 'name', label: 'Nome', type: 'text', required: true }
        ]}
    />
);

export default Banks;
